import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface WebsiteHeaderElementIconProps {
  children?: ReactNode
  className?: string
}

export const WebsiteHeaderElementIcon = ({
  children,
  className,
}: WebsiteHeaderElementIconProps) => {
  return (
    <span
      className={twMerge(
        'flex h-9 w-9 items-center justify-center rounded-sm bg-black/5',
        className,
      )}
    >
      {children}
    </span>
  )
}
